import { LogLevel } from "@azure/msal-browser";
import { environments, getEnvironment } from "../helpers/environmentHelpers";

// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito

// App Registration ID
var env = getEnvironment();
const devId = "1bb20ec8-b7d3-46ab-b6ac-58e63836e080";
const testId = "45ec0d26-ecb3-4c48-8834-13e9919c0043";
const stageId = "cf71fe4a-e1cf-459d-abce-ecf6b787c9ca";
const prodId = "2dbe5d7b-0221-4395-abc6-46501c51a164";

let appId = devId;
switch (env) {
  case environments.LocalDev:
  case environments.Development:
    appId = devId;
    break;
  case environments.Test:
    appId = testId;
    break;
  case environments.Staging:
    appId = stageId;
    break; 
  case environments.Production:
    appId = prodId;
    break;
  default:
    break;
}

export const msalConfig = {
  auth: {
    clientId: appId,
    authority: `https://login.microsoftonline.com/organizations/`,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii || !import.meta.env.REACT_APP_AUTH_LOGGING) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};
